<template>
  <div :class="['card', cardCs]">
    <div class="bg-card blue-bg d-flex flex-column">
      <h3 class="card-title"> Guia basica de CSS 3 </h3>
       <IconCustom
          :width="60"
          :height="60"
          color="#fff">
          
          <IntegrationIcon/>
        </IconCustom>
    </div>
    
    <div class="card-body pt-4">
      <div>
        <p class="card-subtitle text-left">Animate a Blob of Text with SVG and Text Clipping</p>
      </div>
      <div class="author-date d-flex align-items-center justify-content-between mt-3">
        <div class="mt-auto d-flex align-items-center">
          <div class="author-img-container rounded-circle">
            <img class="img-fluid mr-2 rounded-circle" :src="require('@/assets/profile-picture.jpg')" alt="">
          </div>
          <small class="ml-2">Noemi Leon</small>
        </div>
        <div class="d-flex justify-content-end">
          <small class="my-auto">19/11/2020</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCustom from '@/components/IconCustom.vue'
import IntegrationIcon from '@/components/icons/IntegrationIcon.vue'
export default {
  components: {IconCustom, IntegrationIcon},
  props:{
    cardCs:{
      Type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
}
</script>

<style>
.card{
  max-width: 340px;
  min-width: 280px;
  height: auto;
  background: transparent;
  border: solid 1px #d8d8d8;
}
.card-body{
  background-color: #fff;
  border-radius: 0 0 16px 16px;
}
.card-subtitle{
   color: var(--dark-gray);
   font-size: 20px;
   font-weight: bold;
   line-height: 1.2;
}
.author-date small{
   color: #a4a4a5;
   font-size: 15px;
}
.author-img-container{
  width: 30px;
  height: 30px;
  background-color: #dbdcdd;
}
.author-img-container >img{
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.bg-card{
  position: relative;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}
.bg-kitten {
  background-image: url('https://placekitten.com/500/300');
}

.card-title{
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
}
.card-img{
  height: 102px;
  max-width: 80px !important;
}
</style>